export default "__VITE_ASSET__BBOeiduM__"